export const AUTH_COOKIES = {
  EVCORE_TOKEN: "auth-token-evcore",
  EVBASIC_TOKEN: "auth-token-evbasic",
  REALM: "auth-realm",
} as const;

export const PROTECTED_ROUTES = [
  "^/$",
  "^/processes$",
  "^/process/.*",
  "^/subprocess/.*",
  "/cv",

  "/enhance",
  "/evaluation",
  "/faq",
  "/settings",
  "/reports",
  "/jobs",
];

export const PUBLIC_ROUTES = [
  // The route of an invitation to a controlled process
  "^/[^/]+$",
  "/auth/*",
  "/jobboard/callback",
  "/plans",
];
